import {FreeSpinsTriggerView} from 'src/freespinstrigger/FreeSpinsTriggerView';
import {Symbols} from 'src/reels/Symbols';
import {GameViews} from 'src/GameViews';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {GameFlowEvents} from 'src/flow/GameFlowEvents';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class FreeSpinsTriggerModule extends Module<FreeSpinsTriggerView> {
	public static readonly FREE_SPINS_TRIGGER_FINISHED: string = 'FREE_SPINS_TRIGGER_FINISHED';
	public static readonly LEAVING_BONUS_AT: string = 'LEAVING_BONUS_AT';
	public static readonly BONUS_TRIGGER_ANIMATION_FINISHED_AT: string = 'BONUS_TRIGGER_ANIMATION_FINISHED_AT';

	protected _totalScattersCount: number = 0;

	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		this.setView(GameViews.FREE_SPINS_TRIGGER_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameFlowEvents.PLAY_FREE_SPINS_TRIGGER, this.onPlayFreeSpinsTrigger);
		this.onView(FreeSpinsTriggerView.ANIMATION_FINISHED_AT, this.onAnimationFinished);
	}

	protected onPlayFreeSpinsTrigger(): void {
		const logic: GameRecodeLogic = (this.logic as GameRecodeLogic);
		const symbols = logic.getFinalSymbolsPosition().initialSymbols;

		symbols.forEach(reel => {
			reel.forEach(symbol => {
				if (symbol.sym === Symbols.BN && symbol.position.y >= 3) {
					this.eventManager.emitDelayed(FreeSpinsTriggerModule.LEAVING_BONUS_AT, symbol.position);
					this.view.playTriggerAnimationAt(symbol.position);
					this._totalScattersCount++;
				}
			});
		});
	}

	protected onAnimationFinished(eventID: string, symPos: SymbolPosition): void {
		this.eventManager.emitDelayed(FreeSpinsTriggerModule.BONUS_TRIGGER_ANIMATION_FINISHED_AT, symPos);

		if (--this._totalScattersCount === 0) {
			this.eventManager.emitDelayed(FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED);
		}
	}
}



// WEBPACK FOOTER //
// ./src/freespinstrigger/FreeSpinsTriggerModule.ts